import logo from '../assets/JuanCafeLogo.jpg';

export default function LeafLogo({ size = 60 }) {
  return (
    <img
      src={logo}
      alt="Juan Café logo"
      width={size}
      height={size}
      style={{ objectFit: 'contain' }}
    />
  );
}
